/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './reserveSigningKey.defs.js'
export { main as default } from './reserveSigningKey.defs.js'
